import { FormEvent, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import loginBG from "../assets/images/login_background.png";
import Logo from "../components/common/Logo";
import { Typography } from "@mui/material";
import { formFields } from "../utils/formFields";
import FormField from "../components/common/FormField";
import Validation from "../utils/Validation";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getForgetPasswordAction,
  setForgetPasswordAction,
} from "../store/reducers/userSlice";
import { useSelector } from "react-redux";
import Notification from "../components/common/notification/Notification";
import { setNotificationAction } from "../store/reducers/mmymSlice";

const loginFormFields = [formFields?.email];

export default function ForgetPassword() {
  // const { addToast } = useToasts();
  const [formData, setFormData]: any = useState({});
  const [isActionCalled, setIsActionCalled] = useState(false);

  const dispatch = useDispatch();

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    email: formData?.email,
  });

  useEffect(() => {
    const fields: any = {};
    loginFormFields.map((field, index) => {
      fields[field?.id] = "";
      return true;
    });
    setFormData(fields);
  }, []);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };
  const navigate = useNavigate();
  const { user, isForgetPasswordSuccess } = useSelector(
    (state: any) => state?.user
  );

  useEffect(() => {
    if (isActionCalled) {
      if (!isError() && error !== null && isActionCalled) {
        setIsActionCalled(false);
        dispatch(getForgetPasswordAction(formData));
      } else {
        setIsActionCalled(false);
      }
    }
  }, [isActionCalled]);

  const onChangeAction = (e: any) => {
    const id = e?.target?.id;
    const value = e?.target?.value;
    setFormData({
      ...formData,
      [id]: value,
    });
    resetValidator(e.target.id);
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };

  useEffect(() => {
    if (isForgetPasswordSuccess) {
      dispatch(setForgetPasswordAction(false));
      navigate("/reset-password");
    }
  }, [isForgetPasswordSuccess]);

  const handleSignout = () => {
    navigate("/");
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  return !user?.idToken ? (
    <Grid
      container
      component="main"
      sx={{
        height: "100vh",
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        position: "relative",
        zIndex: 1, // Ensure content is above the background image
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${loginBG})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.8, // Set the opacity of the background image
          zIndex: -1, // Place the background image behind the content
        },
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        component={Paper}
        // elevation={6}
        square
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center", // Center vertically
          alignItems: "center", // Center horizontally
          width: "100%",
          "max-width": "100%",
          backgroundColor: "rgba(255, 255, 255, 0.50)",
          padding: "16px 0px",
          borderRadius: "25px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: { xs: "0px 16px", sm: "0px" },
            width: "80%",
          }}
        >
          <Logo isTitle={true} isPosition={true} />
          <Typography
            variant="h1"
            fontWeight={600}
            align="center"
            sx={{ fontSize: { xs: "2rem", sm: "3rem" }, color: "#000000" }}
          >
            Forgot Password
          </Typography>
          <Typography
            variant="h5"
            fontWeight={600}
            sx={{ color: "#000000", textAlign: "center" }}
            mt={2}
          >
            Please enter your registered email here and
            <br /> we’ll send instructions on how to reset the password.
          </Typography>

          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{
              mt: 1,
              // display: "ruby",
              // justifyContent: "center", // Center children horizontally
              // flexDirection: "column", // Align children vertically
              // alignItems: "center",
              // width: '70%'
              width: "100%",
            }}
          >
            <Notification />
            {loginFormFields?.map((field, index) => {
              return (
                <FormField
                  {...{
                    ...field,
                    ...{
                      variant: "outlined", // Adding this variant prop
                      isRounded: true,
                      onChange: onChangeAction,
                      onBlur: onBlurAction,
                      error: error && error[field?.id],
                      helperText: error && error[field?.id],
                      sx: {
                        "& input:-webkit-autofill": {
                          WebkitBoxShadow: "0 0 0 1000px #fff inset",
                          WebkitTextFillColor: "#000",
                          background: "transparent",
                          height: "auto !important",
                        },
                      },
                    },
                  }}
                />
              );
            })}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <Button
                onClick={handleSignout}
                fullWidth
                variant="contained"
                sx={{
                  fontWeight: 600,
                  fontSize: "18px",
                  mt: 3,
                  mb: 2,
                  mr: 2,
                  width: "160px", // Adjust the width as needed
                  borderRadius: "20px", // Set a border radius for rounding
                  padding: "10px 16px",
                  textTransform: "capitalize",
                  backgroundColor: "#076C6B",
                  letterSpacing: 1.5,
                }}
              >
                Back
              </Button>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  fontWeight: 600,
                  fontSize: "18px",
                  mt: 3,
                  mb: 2,
                  width: "260px", // Adjust the width as needed
                  borderRadius: "20px", // Set a border radius for rounding
                  padding: "10px 16px",
                  textTransform: "none !important",
                  backgroundColor: "#076C6B",
                  letterSpacing: 1.5,
                }}
              >
                Reset Password
              </Button>
            </div>
          </Box>
        </Box>
      </Grid>
    </Grid>
  ) : null;
}
